<template>
  <div class="news-card">
    <a :href="result.detailPage" class="news-card__image">
      <DefImg v-if="result.detailPicture" :result="result.detailPicture" max-height="380px" />
      <DefImg v-else-if="result.picture" :result="result.picture" max-height="380px" />
    </a>
    <div class="news-card__header">
      <span v-if="result.date" class="news-card__date">{{ result.date }}</span>
      <a v-if="result.name" :href="result.detailPage" class="def-title-3">{{ result.name }}</a>
    </div>
    <a v-if="result.previewText" :href="result.detailPage" class="news-card__text">{{
      result.previewText
    }}</a>
    <a
      v-if="result.detailPage && messages.btnDetail && screenWidth >= 992"
      :href="result.detailPage"
      class="def-link"
      >{{ messages.btnDetail }}</a
    >
  </div>
</template>

<script>
import { screenWidth } from '@use/useDeviceInfo';
import DefImg from '@components/Def/DefImg/DefImg.vue';

export default {
  name: 'NewsCard',
  components: { DefImg },
  props: {
    result: {
      type: Object,
    },
    messages: {
      type: Object,
    },
  },
  data() {
    return {
      screenWidth,
    };
  },
};
</script>

<style lang="scss">
.news-card {
  background-color: #fff;
  padding: 16px;
  display: grid;
  @include point-md {
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 24px;
    padding: 24px;
    & > *:not(.news-card__image) {
      margin-left: 0;
      margin-right: 0;
    }
  }
  @include point-lg {
    padding: 0 0 32px;
    grid-template-columns: repeat(1, 1fr);
    & > *:not(.news-card__image) {
      margin-left: 32px;
      margin-right: 32px;
    }
  }

  &__image {
    display: block;
    align-self: center;
    margin-bottom: 24px;
    @include point-md {
      margin-bottom: 0;
    }
    @include point-lg {
      margin-bottom: 32px;
    }
    //:deep(.def-img) {
    //}
    //img {
    //  display: block;
    //  max-width: 100%;
    //  max-height: 380px;
    //  margin: 0 auto;
    //}
  }
  &__date {
    font-size: rem(14);
    line-height: 100%;
    color: #757575;
    margin-bottom: 24px;
    order: 2;
    @include point-md {
      margin-bottom: 0;
      margin-top: auto;
    }
    @include point-lg {
      margin-bottom: 8px;
      order: 1;
    }
  }
  &__text {
    font-size: rem(16);
    line-height: 120%;
    color: #363636;
    text-overflow: ellipsis;
    overflow: hidden;
    max-height: 96px;
    @include point-lg {
      font-size: rem(18);
      margin-bottom: 32px;
      max-height: 40px;
    }
  }
  &__header {
    display: flex;
    flex-direction: column;
  }
  .def-link {
    font-weight: 500;
    font-size: rem(12);
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: var(--text-colour-secondary);
    margin-top: auto;
  }
  .def-title-3 {
    margin-bottom: 16px;
    order: 1;
    @include point-lg {
      order: 2;
    }
  }
}
</style>
